"use client";

import Image from 'next/image';
import GlowBackground from "@/components/ui/glow-background";
import { ReactNode, useEffect, useRef } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <GlowBackground className="min-h-screen w-full">
      <div className="flex min-h-screen w-full">
        {/* Left Side - Auth Form Content */}
        <div className="w-full lg:w-1/2 flex flex-col px-5 py-5 lg:px-24 relative">
          {/* Logo - Absolute positioned at top left */}
          <div className="absolute top-5 left-5 lg:left-5">
            <Image
              src="/images/logos/URBIS.AI Branding - Main Logo - Black.svg"
              alt="urbis.ai"
              width={106}
              height={31}
              priority
              className="h-[31px] w-auto"
            />
          </div>

          {/* Content - Flex container to handle spacing */}
          <div className="w-full max-w-[380px] mx-auto flex flex-col flex-1 h-full">
            {children}
          </div>
        </div>

        {/* Right Side - City Image Background with Tagline */}
        <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
          {/* City Background Video */}
          <div className="absolute inset-0">
            <video
              ref={videoRef}
              autoPlay
              muted
              loop
              playsInline
              className="object-cover w-full h-full"
              poster="/images/backgrounds/auth-cityscape.jpg"
            >
              <source src="/images/backgrounds/auth-ny.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80 z-10" />

          {/* Content */}
          <div className="absolute bottom-[60px] right-[60px] w-full flex justify-end z-20">
            <div className="max-w-[430px]">
              <h1 className="font-presto text-d1 text-white text-right">
                <span className="text-white">AI Tools for the people <br /> who run real estate.</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </GlowBackground>
  );
}
